import React, { useEffect, useState } from 'react';
import { Container, Table, Tab, Tabs, Alert, Form, Button} from 'react-bootstrap';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../FireBase'; // Adjust the import path as needed
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import * as XLSX from 'xlsx'; // Import xlsx for Excel export


const Report = () => {
    const [customers, setCustomers] = useState([]);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const customersRef = collection(db, 'users'); // Adjust to your Firestore collection name
                const snapshot = await getDocs(customersRef);
                const customersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCustomers(customersData);
                console.log(customersData);
            } catch (err) {
                setError('Failed to fetch customers');
                console.error(err);
            }
        };

        fetchCustomers();
    }, []);

    // Filter customers based on the search query
    const filteredCustomers = customers.filter(customer =>
        // customer.name.toLowerCase().includes(searchQuery.toLowerCase())
        (customer.name?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    );

   

    return (
        <Container fluid  className='inventory-page'>
            <br />
            <h1>Reports</h1>
            {error && <Alert variant="danger">{error}</Alert>}
         
         
            <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredCustomers.length > 0 ? (
                                filteredCustomers.map(customer => (
                                    <tr key={customer.uid}>
                                        <td>
                                            <Link to={`/customers/${customer.uid}`}>{customer.name}</Link>
                                        </td>
                                        <td>{customer.email}</td>
                                        <td>{customer.phone}</td>
                                       
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">No reports found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
         
        </Container>
    );
};

export default Report;
